import { Box, Grid, Typography } from "@material-ui/core";
import React, { useState } from "react";
import DateRangeIcon from "@material-ui/icons/DateRange";
import RoomOutlinedIcon from "@material-ui/icons/RoomOutlined";
import LinkOutlinedIcon from "@material-ui/icons/LinkOutlined";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import style from "./information.module.scss";
import hoverStyle from "styles/hover-overlay.module.scss";
import { EditInformationDialog } from "./edit-information-dialog";
import { useSelector } from "react-redux";
import { GetUrlBuilderData } from "store/url-builder";

export interface InformationProps {
  builderType: string;
}

export const Information = ({ builderType }: InformationProps) => {
  const builderData = useSelector(GetUrlBuilderData);
  const [informationDialog, setInformationDialog] = useState(false);

  const openInformationDialog = () => setInformationDialog(true);
  const handleCloseInformationDialog = () => setInformationDialog(false);

  return (
    <Box className={hoverStyle.root} width="100%" display="flex">
      <Grid item container xs={12} className={style.informationList}>
        <Grid item container xs={12} justifyContent="space-between">
          <Typography
            variant="subtitle2"
            color="textPrimary"
            className={style.wrapIcon}
          >
            <DateRangeIcon style={{ color: builderData.primaryColor.color }} />{" "}
            <b>Calendar</b>
          </Typography>

          <Typography
            variant="subtitle2"
            color="textPrimary"
            className={style.wrapIcon}
          >
            <LinkOutlinedIcon
              style={{ color: builderData.primaryColor.color }}
            />{" "}
            <b>Links</b>
          </Typography>
          <Typography
            variant="subtitle2"
            color="textPrimary"
            className={style.wrapIcon}
          >
            <RoomOutlinedIcon
              style={{ color: builderData.primaryColor.color }}
            />{" "}
            <b>Navigate</b>
          </Typography>
        </Grid>
      </Grid>
      <Grid
        onClick={openInformationDialog}
        item
        xs={12}
        className={hoverStyle.root_content}
      >
        <Typography
          variant="subtitle2"
          className="d-flex aling-items_center"
          color="textSecondary"
        >
          <EditOutlinedIcon fontSize="small" /> <b>Edit Information</b>
        </Typography>
      </Grid>
      {informationDialog && (
        <EditInformationDialog
          isOpen={informationDialog}
          onClose={handleCloseInformationDialog}
          builderType={builderType}
        />
      )}
    </Box>
  );
};
